import { useCallback } from 'react';
import {
  AllieLoadingConfig,
  RouteConfigLoading,
  UseAllieLogoLoadingOptions,
  UseAllieLogoLoadingReturn,
} from './LogoLoading.types';
import { ALLIE_LOADING_EVENTS, DEFAULT_CONFIG } from './LogoLoading.constant';

const getConfigForRoute = (
  pathname: string,
  customConfig?: AllieLoadingConfig,
  routeConfig?: RouteConfigLoading
): AllieLoadingConfig => {
  const sortedRoutes = Object.keys(routeConfig || {}).sort((a, b) => b.length - a.length);

  for (const route of sortedRoutes) {
    if (pathname.startsWith(route)) {
      return { ...DEFAULT_CONFIG, ...customConfig, ...(routeConfig?.[route] || {}) };
    }
  }

  return { ...DEFAULT_CONFIG, ...customConfig };
};

export const hideAllieLoading = () => {
  window.dispatchEvent(new CustomEvent(ALLIE_LOADING_EVENTS.HIDE_LOADING));
};

export const showAllieLoading = () => {
  window.dispatchEvent(new CustomEvent(ALLIE_LOADING_EVENTS.SHOW_LOADING));
};

export const useAllieLogoLoading = (
  options: UseAllieLogoLoadingOptions
): UseAllieLogoLoadingReturn => {
  const { config, routeConfig } = options;

  const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';

  const currentConfig = getConfigForRoute(currentPath, config, routeConfig);

  const hideLoading = useCallback(() => {
    hideAllieLoading();
  }, []);

  const showLoading = useCallback(() => {
    showAllieLoading();
  }, []);

  const setupAutoHide = useCallback(
    (customTime?: number) => {
      const hideTime = customTime || currentConfig.autoHideTime;
      setTimeout(hideLoading, hideTime);
    },
    [hideLoading, currentConfig.autoHideTime]
  );

  return {
    config: currentConfig,
    hideLoading,
    showLoading,
    setupAutoHide,
  };
};
